import script from "./EditQuoteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditQuoteDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EditQuoteDialog.vue?vue&type=style&index=0&id=97c952fe&lang=css"

const __exports__ = script;

export default __exports__